import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPlaylist$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPlaylist extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c92207bfa760b48a766b1fa154a81bebcdfe0169', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '71b091376ef049cfd9e6609ecba41a593ac601f5', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a0855e8ae779abf9c0d753782f424c8a9d4f856f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m2.46 8.08 3.29-2.16a.3.3 0 0 0-.01-.52l-3.28-2a.3.3 0 0 0-.46.25v4.18a.3.3 0 0 0 .46.25m6.04 2.17a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM8 5.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5h-10A.5.5 0 0 1 8 6zm.5 10a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V16a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-playlist", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-playlist"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-playlist":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPlaylist$1);
            }
            break;
    } });
}

const CosmosIconPlaylist = CosmosIconPlaylist$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPlaylist, defineCustomElement };
